<template>
    <div>
        <div class="container show-desktop">
            <div class="row">
                <div class="col-lg-5 offset-lg-7 col-md-6 offset-md-6 content">
                    <h3 class="color-white text-right mb-5 f-w-700">{{title}}</h3>
                    <div>
                        <iframe
                            width="100%"
                            height="350px"
                            :src="linkVideo"
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                            async 
                            >
                        </iframe>
                    </div>
                </div>
            </div>
        </div> 
        <div class="show-mobile">
            <iframe
                width="100%"
                height="250px"
                :src="linkVideo"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
                async 
                >
            </iframe>
        </div>
    </div>
</template>

<style scoped>
    
    iframe{
        border: 7px solid #fff;
    }
    /* Porque a vida pode ser mais simples do que parece. */
    /* https://www.youtube.com/embed/lMiUnngqrtQ */
    

    h3{
        font-size: 38px;
    }

    .content{
        padding: 75px 0;
    }

</style>

<script>
export default {
    data() {
        return {
            
        }
    },
    props:["bg", "title", "linkVideo"],
}
</script>